import { Navigate, Outlet, useLocation } from "react-router-dom";
import { HomeLoading } from "@/components/home-loading";
import BillingWarningPopup from "@/components/billing-warning-popup";
import { useAuth } from "@babackapp/auth-client/hooks";
import { useDatadogAuthTracking } from "@/hooks/use-datadog-auth-tracking";
import ShopCommandPalette from "@/components/shop-command-palette";
import { useCommandPalette } from "@/hooks/use-command-palette";
import BillingWarningCarrierSetupPopup from "@/components/billing-warning-carrier-setup";
import SuperpowerMfaBanner from "@/components/superpower-mfa-banner";
import { signInUrlReturningTo } from "@/lib/auth/sign-in-redirect";

export default function AppLayout() {
  const auth = useAuth();
  const commandPalette = useCommandPalette();
  const location = useLocation();
  useDatadogAuthTracking();

  if (auth.isAuthenticating) return <HomeLoading />;

  // Signed back in, the user lands where the session was lost.
  if (!auth.isAuthenticated)
    return (
      <Navigate
        to={signInUrlReturningTo(
          `${location.pathname}${location.search}${location.hash}`,
        )}
        replace
      />
    );

  return (
    <>
      <ShopCommandPalette
        isOpen={commandPalette.isOpen}
        onClose={commandPalette.close}
      />
      <BillingWarningPopup />
      <BillingWarningCarrierSetupPopup />
      <SuperpowerMfaBanner />
      <Outlet />
    </>
  );
}
